import React, { createContext, useContext, useState } from 'react';
import Confetti from 'react-confetti';

const CareerContext = createContext();

export const useCareerContext = () => useContext(CareerContext);

export const CareerProvider = ({ children }) => {
    const [isConfettiActive, setIsConfettiActive] = useState(false);
    const [error, setError] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [notification, setNotification] = useState(null);

    function handleError(message) {
        setError(message);
        setTimeout(() => {
            setError("");
        }, 5000);
    }

    function handleNotification(message) {
        setNotification(message);
        setTimeout(() => {
            setNotification("");
        }, 5000);
    }

    function startConfetti(setShowConfetti) {
        setIsConfettiActive(true);
        setTimeout(() => setIsConfettiActive(false), 6500); // hide confetti after 6.5 seconds
    };
    

    return (
        <CareerContext.Provider
            value={{
                isPopupOpen,
                setIsPopupOpen,
                handleError,
                handleNotification,
                startConfetti
            }}
        >
            <div className={`notification ${notification ? 'show' : ''}`}>{notification}</div>
            <div className={`error ${error ? 'show' : ''}`}>{error}</div>
            {isConfettiActive && <Confetti decay={0.8} numberOfPieces={100} />}
            {children}
        </CareerContext.Provider>
    )
}

